export class LayerListItemManager {
    constructor(layer, modelTranslationKeyStore) {
        this.layer = layer;
        this.modelTranslationKeyStore = modelTranslationKeyStore;
    }
    getModelTranslationKeyStore() {
        return this.modelTranslationKeyStore;
    }
    getLayerAndStatus() {
        return this.layer;
    }
}
